import { render, staticRenderFns } from "./selectResult.vue?vue&type=template&id=05f0fc14"
import script from "./selectResult.vue?vue&type=script&lang=js"
export * from "./selectResult.vue?vue&type=script&lang=js"
import style0 from "./selectResult.vue?vue&type=style&index=0&id=05f0fc14&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports